import { Component, OnInit, SimpleChanges, Input, EventEmitter, Output, ElementRef, ViewChild, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { SignaturePadComponent } from 'src/app/commons/signature-pad/signature-pad.component';
import { UtilityService } from 'src/app/services/utility.service';
import { UserDocumentService } from '../../services/user-document.service';
import * as _ from 'lodash';
import { NewFileModalComponent } from 'src/app/files/new-file-modal/new-file-modal.component';
import { Router } from '@angular/router';
import { MapsService } from 'src/app/services/maps.service';
import { AssetService } from 'src/app/services/asset.service';
import { retryWhen } from 'rxjs/operators';


@Component({
  selector: 'app-witness-form',
  templateUrl: './witness-form.component.html',
  styleUrls: ['./witness-form.component.scss']
})
export class WitnessFormComponent implements OnInit {
  @Input('accident') accidentData
  @Input('user') userData
  @Input('documentData') documentDetails
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter();
  @ViewChild('search', { static: false })
  public searchElementRef: ElementRef;
  previousIndex: any;
  witnessForm: FormGroup
  // date: any;
  dateIsValid2
  dateIsValid1
  date1: any;
  loading: boolean;
  sign: boolean;
  dateisValid1: boolean
  dateisValid2: boolean
  isSubmit1: boolean
  isSubmit2: boolean
  isSubmit: boolean;
  injure = [];
  date
  dates
  accidentId
  userId
  accidentDetails
  userDetails
  formDetails
  userName
  accidentLocation
  dateOfIncident
  isEdit = false
  extraDetails
  currentUser
  files: any = [];
  newFiles: any = [];
  user: any;
  isAdmin: boolean;
  latitude: number;
  longitude: number;
  latitude2: number;
  longitude2: number;
  address2: string
  zoom: number;
  address: string;
  count: number = 0;
  person: any[];
  tempLatitude
  tempLongLatitude
  incidentLocation: { coords: { lat: number; lng: number; }; address: string; };
  location: any;
  isMapEdit
  constructor(
    public dialog: MatDialog,
    public router: Router,
    private _mapsService: MapsService,
    private formBuilder: FormBuilder,
    public _utilityService: UtilityService,
    public _assetService: AssetService,
    public userDocumentService: UserDocumentService,
    private ngZone: NgZone
  ) {

  }

  ngOnInit() {
    // let data = JSON.parse(localStorage.getItem('data'));
    // this.injurePerson()
    this.user = JSON.parse(localStorage.getItem('userRoles'));
    console.log("this.user", this.user);
    if (this.user.isAdmin) {
      console.log("this.isAdmin", this.user.isAdmin);
      this.isAdmin = true
    }
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))
    this.loading = false;
    this.isSubmit = false
    this.isSubmit1 = false;
    this.isSubmit2 = false;
    if (this.isEdit) { }
    else {
      this.createForm();
      // this.setCurrentLocation();
    }
    // }
  }




  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES datepicker", changes);
    if (changes.accidentData && changes.accidentData.currentValue) {
      this.accidentId = changes.accidentData.currentValue
    }

    if (changes.userData && changes.userData.currentValue) {
      this.userId = changes.userData.currentValue
    }
    if (changes.documentDetails && changes.documentDetails.currentValue) {
      let data = changes.documentDetails.currentValue
      this.accidentDetails = data.accidentDetails
      this.userDetails = data.userData

      if (data && data.details && data.details.details.witnessForm) {
        this.formDetails = data.details.details.witnessForm
        console.log("here is the Details :::::::", this.formDetails)

        this.extraDetails = data.details
        this.files = data.details.files
        this.isEdit = true
        this.isMapEdit = true
        if (this.formDetails && this.formDetails.sign != "") {
          this.sign = true
        }
        let locationData = data.details.details.witnessForm


        this.latitude = (locationData && locationData.location) ? locationData.location.coords.lat : ''
        console.log("here is the latitude", this.latitude)
        this.longitude = (locationData && locationData.location) ? locationData.location.coords.lng : ''
        this.address = (locationData && locationData.location) ? locationData.location.address : ''

        this.witnessForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }


        // this.latitude2 = (data.details.details.witnessForm && data.details.details.witnessForm.incidentLocation) ? data.details.details.witnessForm.incidentLocation.coords.lat : ''
        // this.longitude2 = (data.details.details.witnessForm && data.details.details.witnessForm.incidentLocation) ? data.details.details.witnessForm.incidentLocation.coords.lng : ''
        // this.address2 = (data.details.details.witnessForm && data.details.details.witnessForm.incidentLocation) ? data.details.details.witnessForm.incidentLocation.address : ''
        // this.witnessForm.value['incidentLocation'] = {
        //   coords: { lat: this.latitude2, lng: this.longitude2 },
        //   address: this.address2
        // }

        this.createForm(this.formDetails)
      } else {

        this.isEdit = false
        this.isMapEdit = false
        if (this.userDetails && this.userDetails._id && this.userDetails._id.user) {
          console.log("this user details", this.userDetails);

          this.userName = this.userDetails._id.user.name
        } else {
          this.userName = this.userDetails.user.name
        }
        // this.accidentLocation = this.accidentDetails.location.address
        this.dateOfIncident = this.accidentDetails.date

        this.createForm()
        this.witnessForm.patchValue({
          accidentDate: this.dateOfIncident
        })
      }
    }


  }


  // FORM GROUP

  createForm(data?) {

    this.witnessForm = this.formBuilder.group({
      name: new FormControl((data && data.name) ? data.name : this.userName, Validators.required),
      occupation: new FormControl((data && data.occupation) ? data.occupation : ''),
      // location: new FormControl((data && data.location) ? data.location : this.accidentLocation),
      injure: this.formBuilder.array(this.injurePersons(data && data.injure ? data.injure : [])),
      accidentDate: new FormControl((data && data.accidentDate) ? data.accidentDate : this.dateOfIncident, Validators.required),
      statement: new FormControl((data && data.statement) ? data.statement : ''),
      // missCloseCall: new FormControl((data && data.missCloseCall) ? data.missCloseCall : ''),
      date: new FormControl((data && data.date) ? data.date : '', Validators.required),
      sign: new FormControl((data && data.sign) ? data.sign : '', Validators.required)
    })

    console.log("this is the final witness form value ", this.witnessForm,);


  }

  get multiplePersonGroup() { return <FormArray>this.witnessForm.get('injure') }
  injurePersons(data): Array<any> {
    console.log("injure function", this.witnessForm);

    if (data && data.length) {
      this.person = []
      this.location = data
      _.forEach(data, async (data) => {
        await this.person.push(new FormGroup({
          injuredPerson: new FormControl(data.injuredPerson),
          incidentLocation: new FormControl(data.incidentLocation)
        }))
      })
      console.log("person", this.person);
      return this.person;
    } else {
      return [this.formBuilder.group({
        injuredPerson: new FormControl(''),
        incidentLocation: new FormControl('')
      })
      ]
    }
  }

  addPerson() {
    this.count++;

    this._mapsService.setCurrentLocation().subscribe((data) => {
      console.log("data------->", data);
      this.latitude2 = data.latitude;
      this.longitude2 = data.longitude;
      this.address2 = data.address
      let data1 = {
        coords: { lat: data.latitude, lng: data.longitude },
        address: this.address2
      }
      // for (let i = 0; i <= this.location.length; i++) {
      //   this.latitude2 = data.latitude
      //   this.longitude2 = data.longitude
      // }
      const control = <FormArray>this.witnessForm.controls.injure

      control.push(this.formBuilder.group({
        injuredPerson: new FormControl(''),
        incidentLocation: new FormControl(data1),
      }))
    })



  }


  deletePerson(data, i) {
    console.log("index value============", i);
    const control = <FormArray>this.witnessForm.controls.injure
    control.removeAt(i)
  }


  // UTILITY


  onChangeEvent(value, formControl) {
    console.log("value of date", value);
    console.log('formControl', formControl);
    this.dateisValid1 = true;
    this.isSubmit1 = false

    if (formControl == 'date') {
      this.witnessForm.patchValue({ date: value })
    }
    else {
      this.witnessForm.patchValue({ accidentDate: value })
      this.dateisValid2 = true;
      this.isSubmit2 = false
    }
    console.log('formgroup value', this.witnessForm.value);
  }


  setCurrentLocation(mapCurrentValue) {
    console.log("hello common map component Return Value...", mapCurrentValue)
    this.latitude = mapCurrentValue.latitude
    this.longitude = mapCurrentValue.longitude
    this.address = mapCurrentValue.address

  }

  setCurrentLocation2(mapCurrentValue, i) {
    console.log("hello common map component Return Value...", mapCurrentValue, i)
    let latitude = mapCurrentValue.latitude
    let longitude = mapCurrentValue.longitude
    let address = mapCurrentValue.address
    let incidentLocation = {
      coords: { lat: latitude, lng: longitude },
      address: address
    };

    const control = <FormArray>this.witnessForm.controls.injure
    control.at(i).patchValue({
      incidentLocation: incidentLocation,
    })

  }


  // markerDragEnd2(event, i) {
  //   console.log('mark drag event check', event, i);
  //   this._mapsService.markerDragEnd(event).subscribe((data) => {
  //     console.log("data------->", data);
  //     let lat = data.latitude;
  //     let lng = data.longitude;
  //     let address2 = data.address;

  //     let incidentLocation = {
  //       coords: { lat: lat, lng: lng },
  //       address: address2
  //     };
  //     console.log("this.incidentLocation============", this.incidentLocation);

  //     const control = <FormArray>this.witnessForm.controls.injure
  //     control.at(i).patchValue({
  //       incidentLocation: incidentLocation,
  //     })

  //   });
  //   // this.location[i].push(this.incidentLocation)
  //   // ((this.witnessForm.get('injure') as FormArray).at(i) as FormGroup).get('incidentLocation').patchValue(this.incidentLocation);
  //   // // this.person.push(this.incidentLocation)
  //   // this.witnessForm.value['incidentLocation'] = this.incidentLocation

  // }

  returnLatitude(item, i) {
    const control = <FormArray>this.witnessForm.controls.injure

    if (control.at(i).value.incidentLocation) {
      let latitude = control.at(i).value.incidentLocation.coords.lat
      return latitude
      console.log("here is the latitude item", latitude)
    }

    else {
      return this.latitude
    }
  }

  returnLongLatitude(item, i) {
    const control = <FormArray>this.witnessForm.controls.injure

    if (control.at(i).value.incidentLocation) {
      let longitude = control.at(i).value.incidentLocation.coords.lng
      // console.log("here is the latitude item", control.at(i).value.incidentLocation)

      return longitude
    }
    else {

      // let incidentLocation = {
      //   coords: { lat: this.latitude, lng: this.longitude },
      //   address: this.address
      // };
      // console.log("this.incidentLocation============", this.incidentLocation);

      // const control = <FormArray>this.witnessForm.controls.injure
      // control.at(i).patchValue({
      //   incidentLocation: incidentLocation,
      // })

      return this.longitude
    }
  }


  addSignature(fomrControl) {
    const dialogRef = this._utilityService.commonDialogBoxOpen(SignaturePadComponent,
      null, '100%', '100%', '100vw', '100vh').afterClosed().subscribe((data) => {
        console.log("data of sign", data);
        this.sign = true
        this.isSubmit = false

        if (fomrControl == 'sign') {
          this.witnessForm.patchValue({
            sign: data
          })
          console.log("sign value", this.witnessForm.value);
        }

      })
  }

  addFileModal() {
    let obj = {
      isIncident: true
    }
    this._utilityService.commonDialogBoxOpen(NewFileModalComponent,
      obj, '', '100%', '100vw', '100vh').afterClosed().subscribe((fileQueue) => {
        console.log("The queue recieved is", fileQueue);
        if (fileQueue == undefined || fileQueue.length == 0) return;

        _.forEach(fileQueue, (file) => {
          if (this.isEdit) {
            this.newFiles.push(file)
          } else {
            this.files.push(file);
          }
        })
        this._utilityService.handleSnackBar({ msg: "File uploaded successfully!", button: "OK" })
      }, err => {
        this._utilityService.handleSnackBar({ msg: "Something went wrong!", button: "OK" })
      });
  }

  deleteFile(event, index) {
    console.log("event if file removed", event, this.isEdit);
    this.files.splice(index, 1)
    console.log("after file removd", this.files);

  }
  deleteNewFile(event, index) {
    this.newFiles.splice(index, 1)
  }

  fileDetails(event) {
    console.log("event ====", event);
    this.previousIndex = event.index
    this.openFilesSideNav.emit({ event })
  }


  // API CALL

  save() {
    console.log("this is for edit form", this.witnessForm.value);
    if (this.witnessForm.valid) {
      this.loading = true;

      if (this.isEdit) {



        let obj = {
          metaObj: {
            title: 'witnessForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          documentMetaId: this.extraDetails.documentMetaId,
          userDocumentId: this.extraDetails._id,
          files: this.files,
          newFiles: this.newFiles,
          details: {}
        }
        this.witnessForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        // this.witnessForm.value['incidentLocation'] = {
        //   coords: { lat: this.latitude2, lng: this.longitude2 },
        //   address: this.address2
        // }

        let details = {
          witnessForm: this.witnessForm.value
        }
        obj['details'] = details
        this.userDocumentService.updateUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data updated successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })


      } else {
        let obj = {
          metaObj: {
            title: 'witnessForm',
          },
          documentId: this.accidentId,
          userId: this.userId,
          onModel: 'accident',
          files: this.files,
          // documentId: this.planFormDetails._id,
          details: {}
        }
        this.witnessForm.value['location'] = {
          coords: { lat: this.latitude, lng: this.longitude },
          address: this.address
        }
        // this.witnessForm.value['incidentLocation'] = {
        //   coords: { lat: this.latitude2, lng: this.longitude2 },
        //   address: this.address2
        // }

        let details = {
          witnessForm: this.witnessForm.value
        }
        obj['details'] = details

        this.userDocumentService.addUserDocument(obj).subscribe((response) => {
          console.log("response of new user document", response);
          this.loading = false
          this._utilityService.handleSnackBar({ msg: "Data added successfully!", button: "OK" })
          this.redirect()
        }, error => {
          console.log("error while submit form", error);
          this._utilityService.handleSnackBar({ msg: error.msg, button: "OK" })
          this.loading = false
        })
      }
    }
    else {
      this.isSubmit = true
      this.isSubmit1 = true
      this.isSubmit2 = true
      this.witnessForm.markAllAsTouched();
    }
  }

  redirect() {
    this._assetService.closeDisplayFile(true)
    let param = {
    }
    param['accidentId'] = this.accidentId
    if (this.isAdmin) {
      this.router.navigate(['/accident/single-accident'], { queryParams: param })
    }
    else {
      this.router.navigate(['/accident'])
    }
  }


  dataAnaliys(data) {
    console.log("here is the analysis data =====>", data)
  }

}











function at(i: any): FormGroup {
  throw new Error('Function not implemented.');
}
